export default __webpack_public_path__ + "static/media/categories_furniture.d3721973.png";